<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 告警管理 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.alarmType" clearable placeholder="告警类型">
                            <el-option
                                v-for="item in alarmTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                         </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.handleStatus" clearable placeholder="处理状态">
                            <el-option
                                v-for="item in handleStatuss"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                         </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.identityCard" placeholder="身份证"></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55"  ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="imageUrl" label="图片" :show-overflow-tooltip="true"  width="80">
                    <template slot-scope="scope">
                         <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.imageUrl" lazy="loading"
                                    style="max-height:250px; max-width:330px"/>
                                <img slot="reference" :src="scope.row.imageUrl" lazy="loading" :alt="scope.row.imageUrl" style="height: 30px;width: 50px">
                            </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="alarmType" label="告警类型" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.alarmType == 'gatherAlarm'">
                            楼道聚集告警
                        </div>
                        <div v-else-if="scope.row.alarmType == 'gateAlarm'">
                            校门名单告警
                        </div>
                        <div v-else-if="scope.row.alarmType == 'behaviorAlarm'">
                            走廊行为告警
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="personType" :show-overflow-tooltip="true" label="告警内容" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.alarmType == 'gateAlarm'">
                            <div v-if="scope.row.personType == '01'">
                                犯罪嫌疑人
                            </div>
                            <div v-else-if="scope.row.personType == '02'">
                                重点关注人员
                            </div>
                            <div v-else-if="scope.row.personType == '03'">
                                VIP访客
                            </div>
                            <div v-else-if="scope.row.personType == '04'">
                                陌生人
                            </div>
                            <div v-else>
                                无
                            </div>
                        </div>
                        <div v-else-if="scope.row.alarmType == 'behaviorAlarm'">
                            {{scope.row.dotmessTypesName}}
                        </div>
                        <div v-else-if="scope.row.alarmType == 'gatherAlarm'">
                            聚集事件
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="videoUrl" label="视频" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.alarmType == 'behaviorAlarm' || scope.row.alarmType == 'gatherAlarm'">
                            <div style="color: red" v-if="scope.row.videoUrl == null || scope.row.videoUrl=='' ">
                                采集中...
                            </div>
                            <div v-else>
                                <a target="_blank" :href="scope.row.videoUrl">查看视频</a>
                            </div>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.name == null || scope.row.name=='' ">
                            无
                        </div>
                        <div v-else>
                            {{scope.row.name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="identityCard" label="身份证" :show-overflow-tooltip="true" width="150">
                     <template slot-scope="scope">
                        <div v-if="scope.row.identityCard == null || scope.row.identityCard=='' ">
                            无
                        </div>
                        <div v-else>
                            {{scope.row.identityCard}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="deviceNo" label="设备编号"  width="150"></el-table-column>
                <el-table-column prop="address" label="设备位置"  :show-overflow-tooltip="true" width="150"></el-table-column>
                <el-table-column prop="gmtCreate" label="告警时间" width="100"></el-table-column>
                <el-table-column prop="handleStatus" label="处理状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.handleStatus == 0">
                            待处理
                        </div>
                        <div v-else-if="scope.row.handleStatus == 1">
                            真实警情
                        </div>
                        <div v-else-if="scope.row.handleStatus == 2">
                            系统误报
                        </div>
                        <div v-else-if="scope.row.handleStatus == 3">
                            人为触发
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="handleBy" label="处理人" width="100"></el-table-column>
                <el-table-column prop="handleDatetime" label="处理时间" width="100"></el-table-column>
                <!-- <el-table-column fixed="right"  width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button style="color: #387EE8;"  v-if="scope.row.handleStatus == 0"
                            @click.native.prevent="setUpdate(scope.row,1)"
                            type="text"
                            size="small">
                            确认
                        </el-button>
                        <el-button style="color: red" v-if="scope.row.handleStatus == 0"
                            @click.native.prevent="setUpdate(scope.row,2)"
                            type="text"
                            size="small">
                            忽略
                        </el-button>
                    </template>
                </el-table-column> -->
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';

    export default {
        name:"Alarm",
        data(){
            return{
                menuName:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    alarmType:"",
                    name:"",
                    identityCard:"",
                    handleStatus:"",
                    deptId:""
                },
                handleStatus:"",
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[],
                handleStatuss:[{
                    value: "",
                    label: '全部'
                },{
                    value: 0,
                    label: '待处理'
                }, {
                    value: 1,
                    label: '真实警情'
                }, {
                    value: 2,
                    label: '系统误报'
                }, {
                    value: 3,
                    label: '人为触发'
                }],
                alarmTypes:[{
                    value: "",
                    label: '全部'
                },{
                    value: "gatherAlarm",
                    label: '楼道聚集告警'
                },{
                    value: 'gateAlarm',
                    label: '校门名单告警'
                }, {
                    value: 'behaviorAlarm',
                    label: '走廊行为告警'
                }]
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // deptCheck(){
            //    this.deptId=this.$refs['rootTree'].getCheckedKeys();
            //    this.getData();
            // },
            getData(){
                let url  = this.listAlarmUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.form.name,
                    identityCard:this.form.identityCard,
                    handleStatus:this.form.handleStatus,
                    alarmType:this.form.alarmType,
                    deptId:this.form.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{

                });
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
            //处理告警
            setUpdate(data,handleStatus){
                let msgTipe="";
                if(handleStatus == 1){
                    msgTipe="该告警确实存在，去处理？"
                }else if(handleStatus == 2){
                    msgTipe="该告警不存在，忽略不进行处理？"
                }
                this.form.id=data.id;
                this.handleStatus=handleStatus;
                this.$commonFn.showConfirm2(msgTipe,this.handleSuccess);
            } ,
            handleSuccess(){
                let url  = this.alarmUpdateUrl;
                let data = {
                    id:this.form.id,
                    handleStatus:this.handleStatus
                };
                // console.log(JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/alarm/Alarm.vue